import {
  Tab as HeadlessTab,
  type TabProps as HeadlessTabProps,
} from "@headlessui/react";
import classNames from "classnames";
import { useContext } from "react";

import TabContext from "./TabContext";

type TabProps = HeadlessTabProps<"button">;

export default function Tab({ className, ...props }: TabProps) {
  const { size, variant, vertical } = useContext(TabContext);

  return (
    <HeadlessTab
      {...props}
      className={({ selected }) =>
        classNames(
          "flex cursor-pointer items-center font-semibold outline-0",
          vertical ? "px-3.5 py-2.5" : "p-3",
          vertical ? "justify-start" : "justify-center",
          variant === "primary" &&
            classNames(
              "hover:border-primary-700 hover:text-primary-700",
              !vertical && "hover:-mb-px hover:border-b-2",
              selected
                ? vertical
                  ? "border-primary-700 bg-primary-50 text-primary-700 -ms-px rounded-md"
                  : "border-primary-700 bg-primary-50 text-primary-700 -mb-px border-b-2"
                : "text-gray-500",
            ),
          variant === "secondary" &&
            classNames(
              selected
                ? "rounded-md bg-white text-sm/5 text-gray-700 shadow-sm"
                : "text-sm/5 text-gray-500 hover:text-gray-700",
            ),
          size === "sm" && "text-sm",
          className,
        )
      }
    />
  );
}
